module.exports = __webpack_public_path__ + "img/investment.0cc68807.svg";